import React from 'react';

export const ProgressBar = (props) => {
    const {currentStage, stagesCount} = props;
    
    const getStages = () => {
			const stages = [];

			for(let i = 0; i < stagesCount; i += 1){
				stages.push(
					<div key={i} className={(currentStage - 1) >= i
						? "progress-bar__stage active"
						: "progress-bar__stage"}>
					</div>
				);
			}

			return stages;
    };
		
    return (
			<div className={`progress-bar ${props.className}`}>
				<div className="progress-bar__title">
					Шаг {currentStage} из {stagesCount}
				</div>
				<div className="progress-bar__line">
					{ getStages() }
				</div>
			</div>
    );
};
